import {html, render as renderHTML} from 'lit-html'
import {LogParser} from './log-parser'
import {repeat} from 'lit-html/directives/repeat'

const logParser = new LogParser('', '')

export async function loadCheckRunLogs(checkRunLogsDisplay: HTMLElement): Promise<void> {
  const url = getCheckRunLogsUrl(checkRunLogsDisplay)
  if (!url) return

  const {blankSlate, logsContainer} = queryElements(checkRunLogsDisplay)

  try {
    const response = await fetch(url, {headers: {'X-Requested-With': 'XMLHttpRequest'}})
    if (!response.ok) {
      throw new Error('Response was not OK')
    }
    const data = await response.text()
    hideBlankSlate(blankSlate)
    await appendCheckRunLogs(logsContainer, data)
  } catch (err) {
    throw err
  } finally {
    hideBlankSlate(blankSlate)
  }
}

function hideBlankSlate(blankSlate: HTMLElement) {
  blankSlate.setAttribute('hidden', 'hidden')
}

function getCheckRunLogsUrl(checkRunLogsDisplay: HTMLElement) {
  return checkRunLogsDisplay.getAttribute('check-run-log-url')
}

async function appendCheckRunLogs(logsContainer: HTMLElement, data: string | string[]) {
  if (typeof data === 'string') {
    logParser.appendData(data)
  } else {
    logParser.appendLines(data, 0)
  }

  const lineIndexes = []
  for (let index = 0; index < logParser.logLines.length; index++) {
    lineIndexes.push(index)
  }
  const template = html`
    ${repeat(lineIndexes, lineIndex => {
      const tmpl = lineTemplate(lineIndex)
      if (!tmpl) return html`<div data-index="${lineIndex}" hidden></div>`
      return html`<div data-index="${lineIndex}">${tmpl}</div>`
    })}
  `
  const element = document.createElement('div')
  renderHTML(template, element)
  logsContainer.appendChild(element)
}

function lineTemplate(index: number) {
  const line = logParser.logLines[index]!
  return logParser.renderTemplate(line, true, true)
}

function queryElements(checkRunLogsDisplay: HTMLElement) {
  return {
    blankSlate: document.querySelector<HTMLElement>('.js-steps-blankslate')!,
    logsContainer: checkRunLogsDisplay.querySelector<HTMLElement>('.js-check-run-log-display-container')!,
  }
}
